// TODO export this constant from web-ui
export enum KeyboardKey {
  Escape = 'Escape',
  Tab = 'Tab',
  Enter = 'Enter',
  Space = ' ',
  Spacebar = 'Space',
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  Left = 'Left',
  Right = 'Right',
  Backspace = 'Backspace',
}
